import Api from '../../shared/Api';
import moment from 'moment';
import ICalendar from '../calendar/ICalendar';
import { IPrintEventsResult } from './Types';

export default class PhotographerCalendarApi {
    static getCalendar(from: any, to: any) {
        let url =
            `/views/photographer-calendars/me` +
            '?fromYear=' +
            from.year() +
            '&fromMonth=' +
            (from.month() + 1) +
            '&fromDay=' +
            from.date() +
            '&toYear=' +
            to.year() +
            '&toMonth=' +
            (to.month() + 1) +
            '&toDay=' +
            to.date();
        return new Api().get(url);
    }

    static updateCalendar(calendar: ICalendar) {
        return new Api().put(`/views/photographer-calendars`, calendar);
    }

    static getCalendarPrintEvents(
        from: moment.Moment,
        to: moment.Moment,
        photographerId?: number
    ): Promise<IPrintEventsResult> {
        let path =
            photographerId === undefined
                ? 'me/GetCalendarItemPrintEvents'
                : `GetCalendarItemPrintEvents/${photographerId}`;
        let url =
            `/views/photographer-calendars/${path}` +
            '?fromYear=' +
            from.year() +
            '&fromMonth=' +
            (from.month() + 1) +
            '&fromDay=' +
            from.date() +
            '&toYear=' +
            to.year() +
            '&toMonth=' +
            (to.month() + 1) +
            '&toDay=' +
            to.date();
        return new Api().get(url);
    }

    static unbookEvent(calendarItemId: number): any {
        return new Api().delete(`/views/photographer-booking/${calendarItemId}`);
    }
}
